import styled from "styled-components";
import { fontFamilies } from "components/shared/tokens/typography";

const TONES = {
  orange: { background: "#fff1e6", color: "#e86c37" },
  blue: { background: "#e4eeff", color: "#1479ff" },
  green: { background: "#e8f7ef", color: "#1a8a4a" },
  grey: { background: "#f0f1f4", color: "#7b8498" },
};

export const FilterFieldFixed = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 277px;
  min-width: 0;
`;

export const StatusTag = styled.span`
  display: inline-flex;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: ${fontFamilies.regular};
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  white-space: nowrap;
  background: ${(props) => (TONES[props.$tone] || TONES.grey).background};
  color: ${(props) => (TONES[props.$tone] || TONES.grey).color};
`;

export const CellStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const CellHint = styled.span`
  font-size: 12px;
  color: #767c8f;
  white-space: nowrap;
`;

export const CellMuted = styled.span`
  font-size: 14px;
  color: #767c8f;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const IconCell = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 14px;
  white-space: nowrap;

  svg {
    flex-shrink: 0;
    color: #767c8f;
  }
`;

export const CopyIconButton = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  padding: 0;
  border: 0;
  background: none;
  color: #293142;
  cursor: pointer;
`;

export const ReferenceCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  width: 100%;
`;

export const DisabledPoId = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #9197a6;
  white-space: nowrap;
`;

export const StateBox = styled.div`
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-top: 0;
  border-radius: 0 0 16px 16px;
  min-height: 240px;
`;
